<table width="100%" class="outer-table">
    <tr>
        <td>
            <table width="100%" class="inner-table">
                <tr>
                    <td align="center" valign="middle">
                        <img src="../../assets/img/alert.png">
                    </td>
                    <td width="100%" valign="middle">
                        <ng-content></ng-content>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</table>
<br>
